import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-teammate-search',
  templateUrl: './teammate-search.component.html',
  styleUrls: ['./teammate-search.component.scss'],
  standalone: false
})
export class TeammateSearchComponent implements OnInit {
  teammateSearchForm: FormGroup;
  teammateID: string = "";
  isLoadingFacilityRoles: boolean = false;
  isLoadingTeammateInformation: boolean = false;



  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    this.teammateSearchForm = this.fb.group({
      teammateId: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
  }

  onSearch(): void {
    if (this.teammateSearchForm.invalid) {
      return;
    }
    this.teammateID = this.teammateSearchForm.get('teammateId')?.value || "";
  }

  get isSearchDisabled(): boolean {
    return !this.teammateSearchForm.get('teammateId')?.value?.trim();
  }

  onTeammateInformationLoaded(isLoading: boolean): void {
    this.isLoadingTeammateInformation = isLoading;
    this.cdr.detectChanges();
  }

  onFacilityRolesLoaded(isLoading: boolean): void {
    this.isLoadingFacilityRoles = isLoading;
    this.cdr.detectChanges();
  }
}
